import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/image/test.png'


const _hoisted_1 = {
  class: "divination__wrapper",
  ref: "hero"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "card"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "divination__tabs" }
const _hoisted_5 = {
  ref: "tabs",
  class: "divination__tabs-wrapper"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "divination__btn-slider-wrapper" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "divination__slider" }
const _hoisted_10 = {
  key: 0,
  class: "divination__slider-mobile"
}
const _hoisted_11 = { class: "divination__slide" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "divination__slide" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "divination__slide" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "divination__btn-slider-wrapper" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "divination__mobile-btn-slider" }
const _hoisted_23 = { class: "divination__btn-slider-wrapper" }
const _hoisted_24 = { class: "divination__btn-slider-wrapper" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  ref: "link",
  class: "divination__link"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Поделитесь предсказанием")
], -1)
const _hoisted_29 = { class: "divination__link-socials" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_divination_tabs = _resolveComponent("divination-tabs")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_btn_white = _resolveComponent("btn-white")!
  const _component_social_icon = _resolveComponent("social-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["divination", { '_cover-header': _ctx.isCoverHeader }]),
    style: _normalizeStyle({ paddingTop: _ctx.paddingTop })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "divination__img",
        style: _normalizeStyle([{"z-index":"1"}, { visibility: 'hidden' }])
      }, _hoisted_3),
      _createElementVNode("div", {
        class: "divination__content",
        style: _normalizeStyle({ height: _ctx.contentHeight })
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.divinationTabs, ({ icon, text }, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["divination__tabs-tab", { 'active': _ctx.activeIndex === index }]),
                key: index,
                onClick: ($event: any) => (_ctx.changeSlide(index))
              }, [
                _createVNode(_component_divination_tabs, {
                  icon: icon,
                  text: text
                }, null, 8, ["icon", "text"])
              ], 10, _hoisted_6))
            }), 128))
          ], 512)
        ]),
        (_ctx.card)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "divination__hero",
              style: _normalizeStyle({ paddingTop: _ctx.heroPaddingTop })
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  ref: "prevBtn",
                  class: "divination__btn-slider _prev",
                  type: "button",
                  disabled: _ctx.isFirstSlide,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.slidePrev && _ctx.slidePrev(...args)))
                }, [
                  _createVNode(_component_inline_svg, {
                    src: require('@/assets/svg/arrow.svg')
                  }, null, 8, ["src"])
                ], 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.isTablet)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_swiper, {
                        "space-between": 40,
                        "centered-slides": true,
                        loop: true,
                        onSwiper: _ctx.onSwiper,
                        onSlideChange: _ctx.onSlideChange
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_swiper_slide, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_divination_tabs, {
                                  icon: _ctx.divinationTabs[0].icon,
                                  text: _ctx.divinationTabs[0].text
                                }, null, 8, ["icon", "text"]),
                                _createElementVNode("div", {
                                  class: "divination__slider-description",
                                  innerHTML: _ctx.card.relationship
                                }, null, 8, _hoisted_12)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_swiper_slide, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_divination_tabs, {
                                  icon: _ctx.divinationTabs[1].icon,
                                  text: _ctx.divinationTabs[1].text
                                }, null, 8, ["icon", "text"]),
                                _createElementVNode("div", {
                                  class: "divination__slider-description",
                                  innerHTML: _ctx.card.career
                                }, null, 8, _hoisted_14)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_swiper_slide, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_divination_tabs, {
                                  icon: _ctx.divinationTabs[2].icon,
                                  text: _ctx.divinationTabs[2].text
                                }, null, 8, ["icon", "text"]),
                                _createElementVNode("div", {
                                  class: "divination__slider-description",
                                  innerHTML: _ctx.card.finance
                                }, null, 8, _hoisted_16)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onSwiper", "onSlideChange"])
                    ]))
                  : (_openBlock(), _createBlock(_component_swiper, {
                      key: 1,
                      modules: [_ctx.EffectFade],
                      "auto-height": true,
                      "grab-cursor": true,
                      "space-between": 50,
                      "centered-slides": false,
                      "fade-effect": { crossFade: true },
                      effect: "fade",
                      onSwiper: _ctx.onSwiper,
                      onSlideChange: _ctx.onSlideChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "divination__slider-description",
                              innerHTML: _ctx.card.relationship
                            }, null, 8, _hoisted_17)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "divination__slider-description",
                              innerHTML: _ctx.card.career
                            }, null, 8, _hoisted_18)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_swiper_slide, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "divination__slider-description",
                              innerHTML: _ctx.card.finance
                            }, null, 8, _hoisted_19)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modules", "onSwiper", "onSlideChange"]))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "divination__btn-slider _next",
                  type: "button",
                  disabled: _ctx.isLastSlide,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.slideNext && _ctx.slideNext(...args)))
                }, [
                  _createVNode(_component_inline_svg, {
                    src: require('@/assets/svg/arrow.svg')
                  }, null, 8, ["src"])
                ], 8, _hoisted_21)
              ])
            ], 4))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          ref: "spread",
          class: _normalizeClass(["divination__spread", { '_disabled': _ctx.isBlockBtn }])
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                class: "divination__btn-slider _prev _mobile",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.slidePrev && _ctx.slidePrev(...args)))
              }, [
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/svg/arrow.svg')
                }, null, 8, ["src"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "divination__btn-slider _next _mobile",
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.slideNext && _ctx.slideNext(...args)))
              }, [
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/svg/arrow.svg')
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_btn_white, { "is-share": _ctx.isShare }, null, 8, ["is-share"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, _hoisted_26)
          ])
        ], 2),
        _withDirectives(_createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialLinks, ({ icon, network }, index) => {
              return (_openBlock(), _createBlock(_component_social_icon, {
                class: "divination__link-icon",
                title: "Расклад таро на новый год",
                icon: icon,
                network: network,
                href: _ctx.shareUrl.href,
                key: index
              }, null, 8, ["icon", "network", "href"]))
            }), 128))
          ])
        ], 512), [
          [_vShow, !_ctx.isShare]
        ])
      ], 4)
    ], 512)
  ], 6))
}